/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class DetailsResponse {
    getFixupPrototypeFunction() { return DetailsResponse.fixupPrototype; }

    static newInstance(model: Partial<DetailsResponse>): DetailsResponse {
        let obj = Object.assign(new DetailsResponse(), model);
        DetailsResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<DetailsResponse>): DetailsResponse {
        if (!model) return null;
        return DetailsResponse.newInstance(<DetailsResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: DetailsResponse) {
        if (!obj) return;

        models.DetailsResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: DetailsResponse): boolean {
        Object.setPrototypeOf(obj, DetailsResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.total_count === undefined) {
            this.total_count = 0;
        }
    }

    /**
     * Total violations count
     */
    total_count: number;

    /**
     * Page count for the violations
     */
    page_count: string;

    /**
     * Details of the violation
     */
    details: Array<any>;

}
